import { useMemo } from "react";

import { useConfig } from "app/contexts";
import { useProvider } from "app/contexts/ProviderContext";
import { providerFilterElement } from "app/utils/filters";

import type { Provider } from "@stacklet/ui";
import type { FilterBooleanOperator } from "__generated__/AppQuery.graphql";

export function getEnabledDashboardsFilterElement(
  provider: Provider,
  systemDashboards = true,
) {
  const providerFilter = providerFilterElement(provider);
  const systemFilter = {
    single: { name: "system", value: systemDashboards.toString() },
  };

  return {
    multiple: {
      operands: [providerFilter, systemFilter],
      operator: "AND" as FilterBooleanOperator,
    },
  };
}

export function useEnabledDashboardsFilterElement(providerOverride?: Provider) {
  const contextProvider = useProvider();
  const provider = providerOverride ?? contextProvider;
  const config = useConfig();

  const systemDashboards = config?.system_dashboards ?? true;

  const filterElement = useMemo(
    () => getEnabledDashboardsFilterElement(provider, systemDashboards),
    [provider, systemDashboards],
  );

  return filterElement;
}
